export default "__VITE_ASSET__B$N$hO5C__"